import { __assign, __extends } from "tslib";
import React from 'react';
import { SplitContext } from './SplitContext';
import { WARN_ST_NO_CLIENT } from './constants';
import { memoizeGetTreatmentsWithConfig } from './utils';
/**
 * SplitTreatments accepts a list of feature flag names and optional attributes. It accesses the client at SplitContext to
 * call the 'client.getTreatmentsWithConfig()' method if the `names` prop is provided, or the 'client.getTreatmentsWithConfigByFlagSets()' method
 * if the `flagSets` prop is provided. It then passes the resulting treatments to a child component as a function.
 *
 * @see {@link https://help.split.io/hc/en-us/articles/360020448791-JavaScript-SDK#get-treatments-with-configurations}
 */
var SplitTreatments = /** @class */ (function (_super) {
    __extends(SplitTreatments, _super);
    function SplitTreatments() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // Using a memoized `client.getTreatmentsWithConfig` function to avoid duplicated impressions
        _this.evaluateFeatureFlags = memoizeGetTreatmentsWithConfig();
        return _this;
    }
    SplitTreatments.prototype.render = function () {
        var _this = this;
        var _a = this.props, names = _a.names, flagSets = _a.flagSets, children = _a.children, attributes = _a.attributes;
        return (React.createElement(SplitContext.Consumer, null, function (splitContext) {
            var client = splitContext.client, lastUpdate = splitContext.lastUpdate;
            var treatments = _this.evaluateFeatureFlags(client, lastUpdate, names, attributes, client ? __assign({}, client.getAttributes()) : {}, flagSets);
            if (!client) {
                _this.logWarning = true;
            }
            // SplitTreatments only accepts a function as a child, not a React Element (JSX)
            return children(__assign(__assign({}, splitContext), { treatments: treatments }));
        }));
    };
    SplitTreatments.prototype.componentDidMount = function () {
        if (this.logWarning) {
            console.log(WARN_ST_NO_CLIENT);
        }
    };
    return SplitTreatments;
}(React.Component));
export { SplitTreatments };
